import { useInfiniteQuery } from "@tanstack/react-query";

import type { ArtifactScope } from "../../shared/customer-context-schemas";
import { listCustomerNotes } from "./api";

export function useCustomerNotes(organizationId: string, scope: ArtifactScope) {
  const query = useInfiniteQuery({
    queryKey: [
      "ops",
      "context",
      organizationId,
      "notes",
      scope.kind,
      scope.kind === "tool" ? scope.toolId : null,
    ],
    queryFn: ({ pageParam }) => listCustomerNotes(organizationId, scope, pageParam),
    initialPageParam: null as string | null,
    getNextPageParam: (page) => page.page.nextCursor,
  });
  return { ...query, notes: query.data?.pages.flatMap((page) => page.notes) ?? [] };
}
